function RolesToSelectBox(roles) {
	var selectedOptions = roles.map(function (p) {			
		return {
			value: p.id.toString(), 			
			label: p.name
		}
	});		
	return selectedOptions;    
}
export default RolesToSelectBox;